<template>
  <div>
    <div name="scroll" :style="{overflow: 'auto', height: pageHeight + 'px'}">
      <group gutter="0px">
        <template v-for="item in followupItems">
          <cell v-if="item.visible && !item.pHidden"
            :key="item.modelId"
            :title="item.title"
            @click.native.stop="onClick(item)"
            is-link
            :status="item.status"
            :progress="item.progress">
            <div class="cell-icon" slot="icon" v-if="item.icon">
              <i class="fa" :class="{['fa-' + item.icon]: item.icon}"></i>
            </div>
            <div class="cell-value" v-if="item.progress">
              填写情况
            </div>
          </cell>
        </template>
      </group>
    </div>
  </div>
</template>

<script>
import Cell from './common/cell'
import Group from './common/group'
import { authenticate, catchExpired } from '../utils/auth'
import { getStorageItem, updateStorageItem } from '../utils/cache'
import { isMiniProgram } from '../utils/isMiniProgram'

export default {
  name: 'QuestList',
  components: { Cell, Group },
  data () {
    return {
      questId: '',
      crfId: '',
      followupItems: []
    }
  },
  computed: {
    pageHeight () {
      return this.$store.getters.getWinHeight
    }
  },
  beforeRouteEnter (to, from, next) {
    document.title = '随访项'
    next(vm => {
      vm.questId = to.query.id || getStorageItem('followupId')
      vm.loadFollowup()
    })
  },
  methods: {
    onClick (item) {
      let hasScore = item.hasScore ? 'true' : 'false'
      updateStorageItem('questitemlistParams', {
        questId: this.questId,
        crfId: this.crfId,
        modelId: item.modelId,
        valueId: item.valueId,
        collection: item.collection,
        title: item.title,
        role: item.role,
        hasScore: hasScore
      })
      if (isMiniProgram()) {
        window.wx.miniProgram.navigateTo({
          url: '../questitemlist/questitemlist' +
          '?questId=' + this.questId +
          '&crfId=' + this.crfId +
          '&modelId=' + item.modelId +
          '&valueId=' + item.valueId +
          '&collection=' + item.collection +
          '&title=' + encodeURI(item.title) +
          '&role=' + item.role +
          '&hasScore=' + hasScore
        })
      } else {
        this.$router.push({
          name: 'questitemlist',
          query: {
            questId: this.questId,
            crfId: this.crfId,
            modelId: item.modelId,
            valueId: item.valueId,
            collection: item.collection,
            title: item.title,
            role: item.role,
            hasScore: hasScore
          }
        })
      }
    },
    loadFollowup () {
      this.$http.get(`${this.httpRoot}/followup/detail`, authenticate({params: {id: this.questId}}))
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success' && res.followup) {
          this.followupItems = res.followup.items || []
          this.crfId = res.followup.crfId || ''
          updateStorageItem('followupItems_' + this.questId, res.followup.items)
          this.loadFollowupFinishProgress()
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    },
    loadFollowupFinishProgress () {
      this.$http.get(`${this.httpRoot}/followup/finish/progress`, authenticate({
        params: {followupId: this.questId, crfId: this.crfId}
      }))
      .then(res => res.json())
      .then(res => {
        if (res.status === 'success' && res.progress) {
          let progress = res.progress || {}
          // update followup.items with progress
          this.followupItems.forEach(item => {
            if (progress[item.modelId]) {
              this.$set(item, 'progress', progress[item.modelId])
            }
          })
        }
      })
      .catch(err => {
        catchExpired(err, this)
      })
    }
  }
}
</script>

<style lang="less">
.cell-icon {
  padding-left: 5px;
  padding-right: 8px;
  color: #3a90e4;
}
.cell-value {
  font-size: 14px;
}
.cell-status {
  width: 21px;
  height: 21px;
  margin: 0 .2em;
}
</style>
